import React, { Component } from "react";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { TextShow } from "../Essentials/TextShow";
import NotificationDescription from "../Notifications/NotificationDescription";

class ApprenticeshipDivisionDescription extends Component {
  render() {
    return (
      <div>
        {this.props.type == "policies-regulations-and-guidelines" ? (
          <TextShow
            title="Policies, Regulations and Guidelines"
            type="APPRENTICESHIP_DIV_POLICIES"
          />
        ) : null}

        {this.props.type == "schemes" ? (
          <div>
            <BreadCrumbOwn title="Schemes" />
            <NotificationDescription
              title="Schemes"
              code="APPRENTICESHIP_DIV_SCHEMES"
            />
          </div>
        ) : null}

        {this.props.type == "annual-apprenticeship-reports" ? (
          <div>
            <BreadCrumbOwn title="Annual Apprenticeship Reports" />
            <NotificationDescription
              title="Annual Apprenticeship Reports"
              code="APPRENTICESHIP_DIV_ANNUAL_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "annual-activity-report" ? (
          <div>
            <BreadCrumbOwn title="Annual Activity Report" />
            <NotificationDescription
              title="Annual Activity Report"
              code="APPRENTICESHIP_DIV_ACTIVITY_REPORT"
            />
          </div>
        ) : null}

        {this.props.type == "compliance-reports" ? (
          <div>
            <BreadCrumbOwn title="Compliance Reports" />
            <NotificationDescription
              title="Compliance Reports"
              code="APPRENTICESHIP_DIV_COMPLIANCE_REPORTS"
            />
          </div>
        ) : null}

        {this.props.type == "special-reports" ? (
          <div>
            <BreadCrumbOwn title="Special Reports" />
            <NotificationDescription
              title="Special Reports"
              code="APPRENTICESHIP_DIV_SPECIAL_REPORTS"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ApprenticeshipDivisionDescription;
